import React from 'react'
import PropTypes from 'prop-types'
import formatMessage from 'format-message'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'

const ReaderToolbarLinks = props => {
  const advancedOptionsTooltip = (
    <Tooltip id="advanced_options_tooltip">
      {formatMessage('Set advanced options')}
    </Tooltip>
  )

  return (
    <div>
      <div className="mt-4">
        <div>
          <OverlayTrigger placement="top" overlay={advancedOptionsTooltip}>
            <a
              className="right_options_links btn btn-myed btn-link-myed btn-xs-myed"
              onClick={props.advancedOptionsModalFunc}
              href="#"
            >
              <div id="advanced_options_button" className="booktools_item_title">
                {formatMessage('Advanced Options')}
              </div>
            </a>
          </OverlayTrigger>
        </div>
        <div>
          <a
            id="support_button"
            className="right_options_links btn btn-myed btn-link-myed btn-xs-myed"
            href="https://myeducator.freshdesk.com/support/home"
            target="_blank"
            rel="noreferrer"
          >
            {formatMessage('Support')}
          </a>
        </div>
      </div>
      <div className="clearfix" />
    </div>
  )
}

ReaderToolbarLinks.propTypes = {
  advancedOptionsModalFunc: PropTypes.func.isRequired,
}

export default ReaderToolbarLinks
